
    <div class="d-flex d-flex-gap-2x flex-column">
      <div fieldmagicGridRow>
        <div
          fieldmagicGridColumn="12"
          class="d-flex d-flex-gap justify-content-end"
        >
         <fieldmagic-primary-button
            label="Add Severity"
            [icon]="[
              {
                icon: 'plus-circle',
                klass: 'text-success'
              }
            ]"
            purpose="icon"
            (click)="onAddSeverity()"
          >
          </fieldmagic-primary-button>

          <fieldmagic-primary-button
            purpose="ai"
            [isInProgress]="generating$ | async"
            (click)="onGenerate()"
          >
          </fieldmagic-primary-button>
        </div>
      </div>

      <div fieldmagicGridRow>
        <div fieldmagicGridColumn="12">
          <table class="table table-bordered">
            <thead>
              <tr>
                <td width="30%">
                  <fieldmagic-text
                    content="Defects"
                    purpose="table-header"
                    [withRequiredMarker]="true"
                  >
                  </fieldmagic-text>
                </td>
                <td width="50%">
                  <fieldmagic-text
                    content="Description"
                    purpose="table-header"
                  >
                  </fieldmagic-text>
                </td>
                <td width="20%">
                  <fieldmagic-text
                    content="Linked Product"
                    purpose="table-header"
                  >
                  </fieldmagic-text>
                </td>
                <td width="5%">
                </td>
              <tr>
            </thead>

            <tbody>
              <ng-container *ngIf="fetching$ | async">
                <tr class="text-center">
                  <td colspan="4">
                    <fieldmagic-icon [spin]="true"></fieldmagic-icon>
                  </td>
                </tr>
              </ng-container>

              <ng-container *ngIf="! (fetching$ | async)">
                <ng-container *ngIf="severities$ | async as severities">
                  <tr
                    *ngIf="isEmpty$ | async"
                    class="text-center"
                  >
                    <td colspan="4">No defects available.</td>
                  </tr>

                  <ng-container *ngFor="let severity of severities; let severity_index = index;">
                    <ng-container *ngIf="! severity.deleted">
                      <tr >
                        <td colspan="4">
                          <div class="d-flex d-flex-gap w-100 align-items-center">
                            <fieldmagic-color-picker-input
                              [standalone]="true"
                              [(ngModel)]="severity.color"
                              [displayValue]="false"
                              [displayOnly]="true"
                            >
                            </fieldmagic-color-picker-input>

                            <fieldmagic-dropdown-input
                              class="w-30"
                              bindValue="dropdown_key"
                              [(ngModel)]="severity.dropdown_key"
                              [standalone]="true"
                              [options]="options$ | async"
                              placeholder="Please select a severity"
                              (ngModelChange)="onSeverityChange($event, severity_index)"
                            >
                            </fieldmagic-dropdown-input>

                            <fieldmagic-primary-button
                              class="ml-auto"
                              tooltip="Remove Severity"
                              purpose="icon"
                              [icon]="[
                                {
                                  icon: 'minus-circle',
                                  klass: 'text-danger'
                                }
                              ]"
                              (click)="onSeverityRemove(severity_index)"
                            >
                            </fieldmagic-primary-button>
                          </div>
                        </td>
                      </tr>
                      <ng-container *ngFor="let fault of severity.faults; let fault_index = index;">
                        <tr *ngIf="! fault.deleted">
                          <td>
                            <fieldmagic-textarea-input
                              class="w-100"
                              placeholder="Defect"
                              [expandable]="true"
                              [standalone]="true"
                              [(ngModel)]="fault.fault"
                              (ngModelChange)="emitChanges()"
                            >
                            </fieldmagic-textarea-input>
                          </td>

                          <td>
                            <fieldmagic-textarea-input
                              class="w-100"
                              placeholder="Description"
                              [expandable]="true"
                              [standalone]="true"
                              [(ngModel)]="fault.description"
                              (ngModelChange)="emitChanges()"
                            >
                            </fieldmagic-textarea-input>
                          </td>

                          <td>
                            <fieldmagic-relate-input
                              [(ngModel)]="fault.item_id"
                              placeholder="Please select a product linked to this defect.."
                              [standalone]="true"
                              moduleName="items"
                              [filter]="{
                                'active': true,
                                'labor': false
                              }"
                              (ngModelChange)="emitChanges()"
                            >
                            </fieldmagic-relate-input>
                          </td>

                          <td>
                            <fieldmagic-primary-button
                              tooltip="Add Fault"
                              purpose="icon"
                              [icon]="[{
                                icon: 'plus-circle',
                                klass: 'text-success'
                              }]"
                              (click)="onAddFault(severity_index)"
                            >
                            </fieldmagic-primary-button>

                            <fieldmagic-primary-button
                              purpose="delete-icon"
                              (click)="onFaultRemove(severity_index, fault_index)"
                              [disabled]="! isSeverityFaultRemovable(severity)"
                              tooltip="Remove Fault"
                            >
                            </fieldmagic-primary-button>
                          </td>
                        </tr>
                      </ng-container>
                    </ng-container>
                  </ng-container>
                </ng-container>
              </ng-container>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  